"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var opacities = {
    "opaque": 1,
    "semiOpaque": 0.5,
    "transparent": 0,
    "hovered": 0.1,
    "pressed": 0.15,
    "selected": 0.15,
    "selectedHovered": 0.2,
    "selectedPressed": 0.25,
    "overlay": 0.65
};
exports.default = opacities;
//# sourceMappingURL=opacities.js.map